import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import CobrancasDepositoCard from './components/CobrancasDepositoCard';

const DepositoCobrancasMain = () => {
  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[{ name: 'Inicio' }, { name: 'Cobranças Depósito' }]}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <CobrancasDepositoCard />
        </Col>
      </Row>
    </Container>
  );
};

export default DepositoCobrancasMain;
